const products = state => state.products
const productDetail = state => state.productDetail
const status = state => state.status
export default {
    products,
    productDetail,
    status
}
